import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OpportunityV2 } from 'models'
import { setOpportunityOnboardingMode } from 'pages/home/data'

// Key used to persist the ServiceNow flag so the header "SN" badge survives a
// hard browser refresh (the opportunity slice itself is memory-only).
const ENABLE_SERVICENOW_KEY = 'enableServicenow'

const initialState: OpportunityV2 = {
  enableServicenow: localStorage.getItem(ENABLE_SERVICENOW_KEY) === 'true',
}

const opportunitySlice = createSlice({
  name: 'opportunity',
  initialState,
  reducers: {
    updateOpportunityInfo: (state: OpportunityV2, action: PayloadAction<OpportunityV2>) => {
      const { payload } = action
      setOpportunityOnboardingMode(payload)
      // Persist the ServiceNow flag whenever it is present in the payload so it
      // can be restored after a refresh. `undefined` means "not part of this
      // response", so we leave the previously stored value untouched.
      if (payload.enableServicenow !== undefined) {
        localStorage.setItem(ENABLE_SERVICENOW_KEY, String(!!payload.enableServicenow))
      }
      return {
        ...state,
        ...payload,
      }
    },
    clear: () => {
      localStorage.removeItem(ENABLE_SERVICENOW_KEY)
      return {}
    },
  },
})

export const { updateOpportunityInfo, clear } = opportunitySlice.actions

export default opportunitySlice.reducer
